import { createContext } from "react";
import type { AquiferLayer, OutletPointLayer, SubBasinLayer } from "../../model/gisLayer.ts";
import type { GenericLayer } from "../../model/genericLayer.ts";
import type { ProjectSeries } from "../../model/dailySeries.ts";
import type { AemetProvenance } from "../../model/storage.ts";
import type { EvalHidProject } from "../../model/types.ts";

/**
 * The project-data slice every editor tab (SubBasinsPanel, OutletPointsPanel,
 * AquifersPanel, SeriesPanel, GenericLayersPanel) reads/writes identically —
 * see ProjectEditingProvider (context.tsx) for why this exists. Deliberately
 * does NOT include per-interaction UI state (map selection, drawing mode,
 * which tab is active...) — that still changes shape per caller and stays as
 * regular props, same reasoning `language` (broadly shared, one shape) is a
 * context while `theme` (a couple of call sites) isn't.
 */
export interface ProjectEditingContextValue {
  project: EvalHidProject;
  onChangeProject: (project: EvalHidProject) => void;
  gisLayer: SubBasinLayer | null;
  onChangeGisLayer: (layer: SubBasinLayer) => void;
  outletPointsLayer: OutletPointLayer;
  onChangeOutletPointsLayer: (layer: OutletPointLayer) => void;
  aquifersLayer: AquiferLayer;
  onChangeAquifersLayer: (layer: AquiferLayer) => void;
  series: ProjectSeries;
  onChangeSeries: (series: ProjectSeries) => void;
  aemetProvenance: Record<number, AemetProvenance>;
  onRecordAemetProvenance: (subBasinCode: number, provenance: AemetProvenance) => void;
  genericLayers: GenericLayer[];
  onChangeGenericLayers: (layers: GenericLayer[]) => void;
}

export const ProjectEditingContext = createContext<ProjectEditingContextValue | null>(null);
